import Reveal, { Eyebrow } from "./Reveal";

const LANGS = [
  { name: "Hindi", native: "हिन्दी" },
  { name: "English", native: "English" },
  { name: "Bengali", native: "বাংলা" },
];

const Languages = () => (
  <section data-testid="languages-section" className="py-20 sm:py-28 bg-white border-y border-zinc-200 overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6">
          <Reveal>
            <Eyebrow>Languages</Eyebrow>
            <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl mt-4 leading-[1.08]">
              The agent speaks the customer's language.
            </h2>
            <p className="text-zinc-600 mt-6 leading-relaxed max-w-lg">
              Hindi, English and Bengali — and it follows the customer if they switch language
              mid-call. Names are always spoken exactly as written, never translated.
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-6">
          <div className="grid grid-cols-3 gap-4">
            {LANGS.map((l, i) => (
              <Reveal key={l.name} delay={i * 0.09}>
                <div
                  data-testid={`language-card-${l.name.toLowerCase()}`}
                  className="aspect-square bg-[#FAF9F6] border border-zinc-200 rounded-2xl flex flex-col items-center justify-center gap-2 hover:border-[#2563EB] hover:-translate-y-1 transition-all duration-500"
                >
                  <span className="font-display font-extrabold text-2xl sm:text-4xl text-zinc-900">{l.native}</span>
                  <span className="font-mono2 text-[10px] uppercase tracking-widest text-zinc-400">{l.name}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Languages;
